import React, { useState, useEffect } from "react";
import {
  postEstado as addEstado,
} from "../helpers/rutaEstados";

import { getLocalidades } from "../helpers/rutaLocalidades";
import { getRutas } from "../helpers/rutaRutas";
import { getIva } from "../helpers/rutaIva";
import "../css/addclienteform.css";

const AddEstadoForm = ({ setShow }) => {
  const [formValues, setFormValues] = useState({
    codest: "",
    estado: "",
  });

  const handleChange = (e) => {
    setFormValues({
      ...formValues,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    addEstado(formValues).then((resp) => {
      console.log("✅ Estado creado:", resp);
      setFormValues({
        codest: "",
        estado: "",
      });
      // setShow(false); // si querés cerrar el modal
    });
  };

  // const [localidades, setLocalidades] = useState({ data: {}, loading: true });
  // const [iva, setIva] = useState({ data: {}, loading: true });
  // const [rutas, setRutas] = useState({ data: {}, loading: true });

  // useEffect(() => {
  //   getLocalidades().then((localidades) =>
  //     setLocalidades({ data: localidades, loading: false })
  //   );
  //   getIva().then((iva) => setIva({ data: iva, loading: false }));
  //   getRutas().then((rutas) => setRutas({ data: rutas, loading: false }));
  // }, []);

  return (
        <div className="container">
          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group mt-3 col-sm-5">
                <label>Estado</label>
                <input
                  type="text"
                  className="form-control"
                  name="estado"
                  maxLength="50"
                  required
                  value={formValues.estado}
                  onChange={handleChange}
                />
              </div>


            </div>


            <div>
              <button
                type="submit"
                className="btn btn-dark mt-5 mb-3"
                id="button"
              >
                Guardar
              </button>
            </div>
          </form>
        </div>

  );
};

export default AddEstadoForm;
